export default __webpack_public_path__ + "static/media/thumbnail-learn.6b52732c.webp";